/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';

interface SetupGuideSourcesOptionArgs {
  icon?: string;
  imageSrc?: string;
  title: string;
  isBold?: boolean;
}

export default class SetupGuideSourcesOption extends Component<SetupGuideSourcesOptionArgs> {
  get isBold() {
    return this.args.isBold ?? true;
  }
}
